import Splide from '@splidejs/splide'

export default defineNuxtPlugin(() => {
  return {
    provide: {
      splide: Splide
    }
  }
})